import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { apiClient } from "@/lib/api-client"

interface ToggleSaveResponse {
  success: boolean
  message: string
  data: { saved: boolean }
}

export function useToggleSaveRitual() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (ritualId: string) => {
      const response = await apiClient.post<ToggleSaveResponse>("/api/rituals/saved", { ritualId })
      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["explore-rituals"] })
      queryClient.invalidateQueries({ queryKey: ["featured-rituals"] })
      queryClient.invalidateQueries({ queryKey: ["saved-rituals"] })
    },
    onError: () => {
      toast.error("Could not save ritual. Please try again.")
    },
  })
}
